"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.5,14.05a2.7,2.7,0,0,1,.17-1H12.06a2.7,2.7,0,1,1,0-5.4h4.61a2.7,2.7,0,0,1,2.22-3.63,5.21,5.21,0,0,0-3.58-1.43H5.23A5.24,5.24,0,0,0,0,7.88v4.65a5.24,5.24,0,0,0,5.23,5.23h.2v4.07a.58.58,0,0,0,1,.41l4.48-4.48h4.41a5.2,5.2,0,0,0,3.2-1.1,2.69,2.69,0,0,1-2-2.61Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.66,9.58,20.25,6.17,20,5.94a1.16,1.16,0,1,0-1.63,1.63l1.67,1.68h-8a1.16,1.16,0,0,0,0,2.31h8l-1.67,1.68A1.15,1.15,0,0,0,20,14.91l.05,0,3.65-3.65A1.16,1.16,0,0,0,23.66,9.58Z",
    fill: "#024965"
  }));
};

exports["default"] = _default;